import * as React from "react";
import "./activityFilterDropDown.scss";
import DropDownList from "../../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import IconWrapper from "../../../../hiberUiKit/src/atoms/Icon/IconWrapper";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import {InvoiceEventCategory} from "../../../../model/invoice/event/InvoiceEventTypeObject";

interface IProps {
	/**
	 * On select callback.
	 * @param {string} item
	 */
	onSelect: (item: string) => void;
	/**
	 * Dropdown items.
	 */
	items: string[];
}

interface IState {
	/**
	 * Indicates if dropdown is visible.
	 */
	dropDownVisible: boolean;
	/**
	 * Selected item id.
	 */
	selectedItemId: string | null | undefined;
}

export default class ActivityFilterDropDown extends React.Component<IProps, IState> {

	dropdown: HTMLDivElement;

	constructor(props: IProps) {
		super(props);
		this.state = {
			dropDownVisible: false,
			selectedItemId: InvoiceEventCategory.All
		};
		this.onDropDownToggle = this.onDropDownToggle.bind(this);
		this.onItemSelect = this.onItemSelect.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	}

	componentDidMount() {
		document.addEventListener("mousedown", this.handleOutsideClick);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleOutsideClick);
	}

	render() {
		return (
			<div ref={(dd) => this.dropdown = dd} className="c-dropdown-filter-wrapper">
				<div className="c-dropdown-filter-wrapper_filter">
					<IconWrapper icon={Icon.Filter} size={14} onClick={this.onDropDownToggle}/>
				</div>
				{this.state.dropDownVisible &&
				<div className="m-dropdown">
					<DropDownList items={this.props.items}
								  itemToId={(item: string) => item}
								  itemToLabel={(item: string) => item}
								  selectedItemId={this.state.selectedItemId}
								  onSelect={this.onItemSelect}/>
				</div>}
			</div>
		);
	}

	/**
	 * On item selected.
	 * @param {string} item
	 */
	onItemSelect(item: string) {
		this.setState({dropDownVisible: false, selectedItemId: item}, () => this.props.onSelect(item));
	}

	onDropDownToggle() {
		this.setState({dropDownVisible: !this.state.dropDownVisible});
	}

	/**
	 * Handle click outside dropdown list.
	 */
	handleOutsideClick(event: any) {
		if (!event || (this.dropdown && !this.dropdown.contains(event.target as HTMLElement))) {
			this.setState({dropDownVisible: false})
		}
	}
}
